module.exports = __webpack_public_path__ + "static/api_times-56a18d8f1343c7473fe2d8ca269b827e.png";